import api from "@/module_user/api/api"

const baseUrl = process.env.VUE_APP_API_URL + "/title-search";

export default {
    async search(text) {
        let response = await api.get(baseUrl + `/autocomplete/${text}`);
        return response.data;
    },
    async isTextSearchActive() {
        let response = await api.get(baseUrl + '/ping');
        return response.data;
    },
    async sync() {
        let response = await api.put(baseUrl + '/records');
        return response.data;
    },
}